// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__JDf5z","col":"CardReaderDesc_col__3bfP6","label":"CardReaderDesc_label__3dphV"};